import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import axios, { isCancel } from 'axios';
import React, { useRef } from 'react';
import { ZHB_UI_STAFF_SELECT_CLS_PREFIX } from './const';
import { Input as SpanUiInput, Loading as SpaLoading, Checkbox as SpaCheckbox } from '@tencent/spaui';
import { Search } from '@tencent/adp-icons-react';
import { useDebounceEffect, useMemoizedFn, useSetState } from 'ahooks';
import { ZhbSelectWecomOpenData } from './ZhbSelectWecomOpenData';
import { ZhbEmptyBlock } from '@tencent/zhb-biz-react-ui';
var rootCls = "".concat(ZHB_UI_STAFF_SELECT_CLS_PREFIX, "-search-select");
export var SearchSelectList = function SearchSelectList(props) {
  var value = props.value,
    onValueChange = props.onValueChange,
    onSearch = props.onSearch,
    deptInfoDict = props.deptInfoDict,
    corpId = props.corpId;
  var _useSetState = useSetState({
      dts: [],
      loading: true,
      keyword: ''
    }),
    _useSetState2 = _slicedToArray(_useSetState, 2),
    state = _useSetState2[0],
    setState = _useSetState2[1];
  var cancelRef = useRef(function () {
    return void 0;
  });
  useDebounceEffect(function () {
    if (!state.keyword.trim()) {
      cancelRef.current();
      setState({
        dts: [],
        loading: false
      });
      return;
    }
    cancelRef.current();
    onSearch(state.keyword, {
      cancelToken: new axios.CancelToken(function (c) {
        return cancelRef.current = c;
      })
    }).catch(function (err) {
      if (!isCancel(err)) {
        setState({
          loading: false
        });
      }
      throw err;
    }).then(function (res) {
      var list = [];
      res.forEach(function (resItem) {
        resItem.departmentIdList.forEach(function (deptId) {
          var _a;
          list.push({
            userId: resItem.userId,
            userName: resItem.userName,
            deptId: deptId.toString(),
            deptName: (_a = deptInfoDict[deptId]) === null || _a === void 0 ? void 0 : _a.name
          });
        });
      });
      setState({
        loading: false,
        dts: list
      });
    });
  }, [state.keyword], {
    wait: 300
  });
  var onCheckChange = useMemoizedFn(function (item, nextChecked) {
    var nextValue = _toConsumableArray(value);
    var idx = value.findIndex(function (val) {
      return val.type === 'user' && item.deptId === val.parentId && item.userId === val.id;
    });
    if (nextChecked && idx === -1) {
      nextValue.push({
        type: 'user',
        id: item.userId,
        name: item.userName,
        parentId: item.deptId,
        parentName: item.deptName
      });
      onValueChange(nextValue);
    }
    if (!nextChecked && idx > -1) {
      nextValue.splice(idx, 1);
      onValueChange(nextValue);
    }
  });
  var getContent = function getContent() {
    if (!state.keyword.trim()) {
      return null;
    }
    var node;
    if (state.loading) {
      node = React.createElement(SpaLoading, {
        className: "".concat(rootCls, "-loading"),
        circleSize: 24,
        display: "center"
      });
    } else if (state.dts.length === 0) {
      node = React.createElement(ZhbEmptyBlock, null);
    } else {
      node = state.dts.map(function (item) {
        var checked = !!value.find(function (val) {
          return val.type === 'user' && val.parentId === item.deptId && val.id === item.userId;
        });
        return React.createElement(SpaCheckbox, {
          checked: checked,
          key: "".concat(item.deptId, "-").concat(item.userId),
          onChange: function onChange() {
            return onCheckChange(item, !checked);
          },
          className: "".concat(rootCls, "-list-item"),
          label: React.createElement("span", {
            className: "".concat(rootCls, "-list-item-text")
          }, React.createElement(ZhbSelectWecomOpenData, {
            corpId: corpId,
            value: {
              type: 'dept',
              id: item.deptId,
              name: item.deptName
            }
          }), "\xA0/\xA0", React.createElement(ZhbSelectWecomOpenData, {
            corpId: corpId,
            value: {
              type: 'user',
              id: item.userId,
              name: item.userName,
              parentId: item.deptId,
              parentName: item.deptName
            }
          }))
        });
      });
    }
    return React.createElement("div", {
      className: "".concat(rootCls, "-content")
    }, node);
  };
  return React.createElement("div", {
    className: rootCls
  }, React.createElement(SpanUiInput, {
    wrapperClassName: "".concat(rootCls, "-input"),
    placeholder: "\u641C\u7D22\u5458\u5DE5",
    prefix: React.createElement(React.Fragment, null, React.createElement(Search, {
      size: 16,
      fill: "#898B8F"
    }), "\xA0"),
    value: state.keyword,
    onChange: function onChange(_, keyword) {
      return setState({
        keyword: keyword,
        loading: true
      });
    }
  }), getContent());
};